import { FC, Fragment, useMemo } from 'react';
import ContentLoader from 'react-content-loader';
import { useTheme } from 'styled-components/macro';

import { getLoaderIndents } from '../../helpers';
import { useResponsive } from 'contexts/ResponsiveContext';

const NotificationsHistoryLoader: FC = () => {
  const theme = useTheme();
  const { isMobile } = useResponsive();
  const loaderIndents = useMemo(() => getLoaderIndents(isMobile), [isMobile]);

  return (
    <ContentLoader
      speed={2}
      width="100%"
      height="100%"
      backgroundColor={theme.colors.white}
      foregroundColor={theme.colors.primary.variant6}
    >
      {loaderIndents.map(
        ({ avatarIndent, dateTimeIndent, messageIndent, descriptionIndent }, i) => (
          <Fragment key={`notifications-loader-${i}`}>
            (
            <rect x="0" y={avatarIndent} rx="50%" ry="50%" width="32" height="32" />
            <rect x="38" y={dateTimeIndent} rx="2" ry="2" width="140" height="6" />
            <rect x="38" y={messageIndent} rx="2" ry="2" width="240" height="6" />
            <rect x="38" y={descriptionIndent} rx="2" ry="2" width="190" height="6" />)
          </Fragment>
        )
      )}
    </ContentLoader>
  );
};

export default NotificationsHistoryLoader;
